import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;
const api = new API(BASE_URL);

class OwnerService {
  static fetchLegalForms = () => api.get(urls.OWNER.FETCH_LEGAL_FORMS);

  static fetchLicenseSources = () => api.get(urls.OWNER.FETCH_LICENSE_SOURCES);

  static validateCompany = params => api.get(urls.OWNER.VALIDATE_COMPANY, null, params);

  static fetchCompanyDetails = appId => api.get(urls.OWNER.FETCH_COMPANY_DETAILS, appId);

  static addCompany = data => api.post(urls.OWNER.ADD_COMPANY, data);

  static submitCompanyApplication = data => api.post(urls.OWNER.SUBMIT_COMPANY_APPLICATION, data);

  static searchOwner = data => api.post(urls.OWNER.SEARCH_OWNER, data);

  static fetchCompanyByLicense = licenseNo => api.get(urls.OWNER.FETCH_COMPANY_BY_LICENSE, null, { licenseNo });

  static fetchCompanyReserve = license => api.get(urls.OWNER.FETCH_COMPANY_RESERVE, license);

  static addOwnerIndividual = payload => api.post(urls.OWNER.ADD_OWNER_INDIVIDUAL, payload);

  static addOwnerCompany = payload => api.post(urls.OWNER.ADD_OWNER_COMPANY, payload);

  static addRepresentative = payload => api.post(urls.OWNER.ADD_REPRESENTATIVE, payload);

  static fetchPoAApplication = appId => api.get(urls.OWNER.FETCH_POA_DETAILS, appId);

  static fetchPoATypes = params => api.get(urls.OWNER.FETCH_POA_TYPES, null, params);

  static fetchPoAById = id => api.get(urls.OWNER.FETCH_POA_BY_ID, id);

  static addPoA = payload => api.post(urls.OWNER.ADD_POA, payload);

  static submitPoA = payload => api.post(urls.OWNER.SUBMIT_POA, payload);

  static fetchOwnerById = id => api.get(urls.OWNER.FETCH_OWNER_BY_ID, id);

  static saveEmployee = payload => api.post(urls.OWNER.SAVE_EMPLOYEE, payload);

  static removeEmployeeProperty = (appId, plotId) =>
    api.delete(urls.OWNER.REMOVE_EMPLOYEE_PROPERTY, `${appId}/${plotId}`);

  static fetchEmployeeProperties = payload => api.post(urls.OWNER.FETCH_EMPLOYEE_PROPERTIES, null, payload);

  static fetchCompnayEmployees = params => api.get(urls.OWNER.FETCH_EMPLOYEE_LIST, null, params);

  static fetchCompnayEmployeeById = userId => api.get(urls.OWNER.FETCH_EMPLOYEE, userId);

  static deleteCompnayEmployee = userId => api.delete(urls.OWNER.DELETE_EMPLOYEE, userId);

  static deactivateCompanyEmployee = ({ userId }) => api.put(urls.OWNER.DEACTIVATE_EMPLOYEE, null, userId);

  static reactivateCompanyEmployee = userId => api.put(urls.OWNER.REACTIVATE_EMPLOYEE, null, userId);

  static fetchEmployeePropertiesById = userId => api.post(urls.OWNER.FETCH_EMPLOYEE_PROPERTIES_USERID, null, userId);

  static fetchEmployeePermissions = () => api.get(urls.OWNER.FETCH_EMPLOYEE_PERMISSIONS);

  static fetchEmployeeApplication = appId => api.get(urls.OWNER.FETCH_EMPLOYEE_APPLICATION, appId);

  static finalEmployeeSave = params => api.post(urls.OWNER.FINAL_EMPLOYEE_SAVE, params);

  static checkoutEmployeeForm = appId => api.post(urls.OWNER.CHECKOUT_EMPLOYEE_FORM, null, null, appId);

  static addBuyerPerson = data => api.post(urls.OWNER.ADD_BUYER_PERSON, data);

  static addBuyer = data => api.post(urls.OWNER.ADD_BUYER, data);

  static addBuyerPersonMusataha = data => api.post(urls.OWNER.ADD_BUYER_PERSON_MUSATAHA, data);

  static deleteBuyerPersonMusataha = params => api.deleteWithBody(urls.OWNER.ADD_BUYER, null, params);

  static addBuyerCompany = data => api.post(urls.OWNER.ADD_BUYER_COMPANY, data);

  static fetchPoaCustomers = () => api.get(urls.OWNER.FETCH_POA_OWNERS);

  static addBroker = data => api.post(urls.OWNER.ADD_BROKER, data);

  static deleteBroker = id => api.delete(`${urls.OWNER.ADD_BROKER}/${id}`);

  static addOffplanPOA = data => api.post(urls.OWNER.ADD_OFFPLAN_POA, data);

  static deletePOA = params => api.deleteWithBody(urls.OWNER.ADD_OFFPLAN_POA, null, params);

  static fetchProfileEnabledServices = () => api.get(urls.OWNER.FETCh_PROFILE_ENABLED_SERVICES);

  static fetchGovernmentCompanies = params => api.get(urls.OWNER.FETCH_GOVERNMENT_COMPANIES, null, params);

  static checkCompanyAdmin = params => api.get(urls.OWNER.CHECK_COMPANY_ADMIN, null, params);

  // Common
  static fetchUserById = (id, params) => api.get(urls.OWNER.FETCH_USER_BY_ID, id, params);

  static fetchNonUAEUser = params => api.get(urls.OWNER.FETCH_NON_UAE_USER, null, params);

  static fetchCompany = licenseNo => api.get(urls.OWNER.FETCH_CN_IN_COMPANY, licenseNo);

  static fetchGOVCompanies = params => api.get(urls.OWNER.FETCH_GOV_COMPANIES, null, params);

  static savePartiesDetailsInDBUserTable = data => api.post(urls.OWNER.SAVE_PARTIES_DETAILS_TO_DB_USERS_TABLE, data);
}

export default OwnerService;
